(function () {
  if (window.__customSlideshowBannerLoaded) return;
  window.__customSlideshowBannerLoaded = true;

  class CustomSlideshowBanner {
    constructor(el) {
      if (el.__slideshowInstance) return;
      el.__slideshowInstance = this;

      this.el = el;
      this.slides = Array.from(el.querySelectorAll('.custom-slideshow-banner__slide'));
      this.dots = Array.from(el.querySelectorAll('.custom-slideshow-banner__dot'));
      this.prevBtn = el.querySelector('.custom-slideshow-banner__arrow--prev');
      this.nextBtn = el.querySelector('.custom-slideshow-banner__arrow--next');
      this.current = 0;
      this.autoplay = el.dataset.autoplay === 'true';
      this.autoplaySpeed = parseInt(el.dataset.autoplaySpeed, 10) || 5000;
      this.timer = null;

      if (this.slides.length <= 1) return;

      this.prevBtn?.addEventListener('click', () => this.go(this.current - 1));
      this.nextBtn?.addEventListener('click', () => this.go(this.current + 1));
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));

      this.el.addEventListener('mouseenter', () => this.stop());
      this.el.addEventListener('mouseleave', () => this.start());

      this.start();
    }

    go(index) {
      const total = this.slides.length;
      this.current = (index + total) % total;

      this.slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === this.current);
      });
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === this.current);
      });
    }

    start() {
      if (!this.autoplay) return;
      this.stop();
      this.timer = setInterval(() => this.go(this.current + 1), this.autoplaySpeed);
    }

    stop() {
      if (this.timer) clearInterval(this.timer);
    }
  }

  document.querySelectorAll('.custom-slideshow-banner').forEach((el) => new CustomSlideshowBanner(el));

  document.addEventListener('shopify:section:load', (event) => {
    const el = event.target.querySelector('.custom-slideshow-banner');
    if (el) new CustomSlideshowBanner(el);
  });
})();